import './Blogs.scss';
import Carousel from '../utils/Carousel';
import TalentCard from './TalentCard';
import Header from '../utils/Header';
import LeftArrow from '../../images/left-arrow-white.png';
import RightArrow from '../../images/right-arrow-white.png';
import toList from '../utils/ComponentUtil';

function ScrollableCards({style={}, title = undefined, subtitle = undefined, talents = [], readMore = false, card = TalentCard, noOfCards = 3}) {
    talents = talents.map(d => { return { ...d, readMore: readMore } });
    return (
        <div className="blogs-wrp wrapper" id="blogs" style={style}>
            <div className='blogs-content-wrp'>
                <Header title={title} subTitle={subtitle} />
                <div className="blogs-content">
                    <Carousel numberOfCards={noOfCards} partialVisbile={true} leftArrow={LeftArrow} rightArrow={RightArrow}
                        cards={toList([...talents], card)}
                    ></Carousel>
                </div>
            </div>
        </div>
    );
}

export default ScrollableCards;